import { DateRangePicker } from './date-range-picker.js';
import autoComplete from './autocomplete';


/* eslint-disable */
"use strict";
/* Utils */
var SEGUROS_PROMO_BASE = 'https://www.segurospromo.com.br';
// TODO: ALTERAR AQUI VIA DOCKER
var SEARCH_PAGE_BASE = `/site/pesquisa/`;
var CLIENT_API_URL = "/emitir-seguros/access/";
// https://7f4d2adec03c419fa2d42db41c0915c6@log.emitir.com.br/32
var RAVENURL = '';

var ua = navigator.userAgent.toLowerCase();

function mobilechecker() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

function extend(obj, defaults, options) {
  var option;
  for(option in defaults) {
    obj[option] = defaults[option];
  }
  for(option in options) {
    if (defaults.hasOwnProperty(option)) {
      obj[option] = options[option];
    }
  }
}

var httpSpDo = function (method, url, callback, data) {
  var xmlHttp = new XMLHttpRequest();
  xmlHttp.onreadystatechange = function () {
    if (xmlHttp.readyState === 4) {
      if (typeof callback === "function") {
        callback(xmlHttp.responseText);
      }
    }
  };
  xmlHttp.open(method, url);
  xmlHttp.send(data);
};

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
          c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
      }
  }
  return "";
}

function setCookie(name, value, daysToExpire) {
  daysToExpire = (typeof daysToExpire !== 'undefined') ? daysToExpire : 1;
  var d = new Date();
  d.setTime(d.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
  var expires = 'expires=' + d.toUTCString();
  document.cookie = name + '=' + value + '; ' + expires + '; path=/';
}

var obj, masc;
function fMasc(objeto,mascara) {
  obj=objeto;
  masc=mascara;
  setTimeout("fMascEx()",1);
}

function fMascEx() {
  obj.value=masc(obj.value);
}

function mTel(tel) {
  tel=tel.replace(/\D/g,"")
  tel=tel.replace(/^(\d)/,"($1")
  tel=tel.replace(/(.{3})(\d)/,"$1)$2")
  if(tel.length == 9) {
    tel=tel.replace(/(.{1})$/,"-$1")
  } else if (tel.length == 10) {
    tel=tel.replace(/(.{2})$/,"-$1")
  } else if (tel.length == 11) {
    tel=tel.replace(/(.{3})$/,"-$1")
  } else if (tel.length == 12) {
    tel=tel.replace(/(.{4})$/,"-$1")
  } else if (tel.length > 12) {
    tel=tel.replace(/(.{4})$/,"-$1")
  }
  return tel;
}

function handler(errorCode, lib) {
  if (lib.onError.hasOwnProperty(errorCode) && typeof lib.onError[errorCode] === "function") {
    lib.onError[errorCode](lib.frame);
  }
}

function Frame(options) {
  var self = this;
  var defaults = {
    destination: null,
    departureDate: null,
    returningDate: null,
    client: true,
    nullEndDate: false,
    name: null,
    onSuccess: null,
    openInNewTab: true,
    form: null,
    email: null,
    cellphone: null,
    valid: false
  };

  extend(this, defaults, options);

  this.submit = function(ev) {
    self.validate(true);

    if (!self.valid) {
      ev.preventDefault();
      return
    }

    var subscriber = {
      name: self.name.getName(),
      cellphone: self.cellphone.getCellphone(),
      email: self.email.getEmail(),
    };

    var token = btoa(JSON.stringify(subscriber));
    setCookie("sp-client", token);
  }

  this.search = function(ev) {
    ev.preventDefault();
    self.validate(true);
    if (self.valid) {

      if (self.client) {
        var subscriber = {
          name: self.name.getName(),
          cellphone: self.cellphone.getCellphone(),
          email: self.email.getEmail(),
        };

        var token = btoa(JSON.stringify(subscriber));
        setCookie("sp-client", token);
        self.sendClientData(subscriber, self.afterSearch, self.afterSearch);
      } else {
        self.afterSearch();
      }
    }
  }

  this.afterSearch = function(response) {
    var urlToRedirect = SEGUROS_PROMO_BASE + SEARCH_PAGE_BASE + self.destination.getSelected().slug + '/' + self.departureDate.date.toEn().replace(/\//g, '-') + ((self.returningDate) ? '/' + self.returningDate.date.toEn().replace(/\//g, '-') : '');
    if (!self.onSuccess) {
      if (self.openInNewTab) {
        var win = window.open(urlToRedirect, '_blank');
        (win) && win.focus();
      } else {
        window.location = urlToRedirect;
      }
      return;
    }

    self.onSuccess(self, urlToRedirect);
  };


  this.sendClientData = function(subscriber, callback, afterSearch) {
    var token = btoa(JSON.stringify(subscriber));
    setCookie("sp-client", token);

    var clientUrl = SEGUROS_PROMO_BASE + CLIENT_API_URL + '?name=' + subscriber.name + '&email=' + subscriber.email + '&phone=' + self.cellphone.toPhone(subscriber.cellphone).split(')')[0] + ' ' + self.cellphone.toPhone(subscriber.cellphone).split(')')[1];
    httpSpDo('GET', clientUrl, callback);
  }

  this.validate = function(ignorePristine) {
    var error = false;
    self.destination.validate(ignorePristine);
    self.departureDate.validate(ignorePristine);
    if (self.returningDate) {
      self.returningDate.validate(ignorePristine);
    }

    if (self.client) {
      self.name.validate(ignorePristine);
      self.email.validate(ignorePristine);
      self.cellphone.validate(ignorePristine);

      if (self.email.error || self.name.error || self.cellphone.error) {
        error = true;
      }
    }


    if (error || self.destination.error || self.departureDate.error || ((self.returningDate) ? self.returningDate.error : false)) {
      self.valid = false;
    } else {
      self.valid = true;
    }
  };

  this.init = function() {
    if (!self.destination) console.error("Input de destino não definido");
    else self.destination.frame = self;

    if (!self.departureDate) console.error("Data de partida não definda");
    else self.departureDate.frame = self;

    if (!self.returningDate && !self.nullEndDate) {
      console.error("Data de retorno não definida");
    } else {
      if (self.returningDate) {
        self.returningDate.frame = self;
      }
    }

    if (self.client) {
      if (!self.name) console.error("Input de nome não definido");
      else self.name.frame = self;

      if (!self.email) console.error("Input de email não definido");
      else self.email.frame = self;

      if (!self.cellphone) console.error("Input de telefone não definido");
      else self.cellphone.frame = self;

      var cookies = getCookie('sp-client');
      var client = (cookies) ? JSON.parse(atob(cookies)) : null;
      if (client) {
        self.name.setName(client.name);
        self.email.setEmail(client.email);
        self.cellphone.setPhone(client.cellphone);
        self.sendClientData(client);
      }
    }

    // Setup sentry.
    var script = document.createElement('script');
    script.async = 'async';
    script.src = "https://cdn.ravenjs.com/3.1.1/raven.min.js";
    document.head.appendChild(script);

    setTimeout(function() {
      if (typeof Raven !== 'undefined') {
        Raven.config(RAVENURL).install()
      } else {
        console.log('raven not loaded')
      }
    }, 1000);

    if (!getCookie("segpromuuid")) {
      function guid() {
        function s4() {
          return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
      }
      setCookie("segpromuuid", guid());
    }
  };

  this.init();

  if (this.form) {
    this.form.addEventListener('submit', this.submit);
  }
}

function Destination(options) {
  var self = this;
  var defaults = {
    input: null,
    optionsDiv: null,
    container: null,
    selected: null,
    offsetTop: 5,
    error: true,
    options: [],
    onChange: null,
    onError: {},
    pristine: true,
    onSelect: null,
    initialValue: '',
  };
  extend(this, defaults, options);

  this.init = function() {
    var defaultDestinations = [
      {value:"1", name: "Brasil", slug: "brasil"},
      {value:"2", name: "América do Sul", slug: "america-do-sul"},
      {value:"3", name: "Europa", slug: "europa"},
      {value:"4", name: "América do Norte", slug: "america-do-norte"},
      {value:"5", name: "América Central", slug: "america-central"},
      {value:"6", name: "Oceania", slug: "oceania"},
      {value:"7", name: "Oriente Médio", slug: "oriente-medio"},
      {value:"8", name: "Ásia", slug: "asia"},
      {value:"9", name: "África", slug: "africa"},
      {value:"11", name: "Internacional", slug: "internacional"},
      {value:"12", name: "Receptivo", slug: "receptivo"},
      {value:"16", name: "Argentina", slug: "argentina"},
    ];
    self.options = defaultDestinations;
    if (self.input) {
      this.input.value = this.initialValue || 'Destino';
      self.autoComplete = new autoComplete({
        minChars: 0,
        selector: self.input,
        delay: 0,
        offsetTop: self.offsetTop,
        source: function(_, response) {
          response(defaultDestinations);
        },
        renderItem: function (item, _){
          return '<div class="autocomplete-suggestion'+ ((self.selected == item.value) ? ' autocomplete-suggestion-selected' : '') + '" data-val="' + item.name + '" value="' +  item.value + '">' + item.name + '</div>';
        },
        onSelect: function(e, _, item) {
          e.preventDefault(); // necessário para o 'enter' não disparar a pesquisa
          self.setDestination(item.getAttribute('value'));
        },
      });
    }
  };

  this.validate = function(ignorePristine) {
    if (self.pristine && !ignorePristine) {
      return;
    }

    if (!self.selected) {
      handler("INVALID_VALUE", self);
      self. error = true;
      return;
    }

    self.error = false;
  };

  this.blur = function() {
    setTimeout(function() {
      self.frame.validate();
    }, 10);
  };

  this.focus = function() {
    self.pristine = false;
  };

  this.change = function() {
    self.onChange();
  };

  this.getSelected = function() {
    for (var i = 0; i < self.options.length; i ++) {
      if (self.options[i].value == self.selected) {
        return self.options[i];
      }
    }
  };

  this.setDestination = function(option) {
    self.selected = option;
    if (self.input) {
      self.input.value = self.getSelected().name;
    }
    self.change();
  };

  if (self.input) {
    this.input.addEventListener('input', self.change)
    this.input.addEventListener('blur', self.blur);
    this.input.addEventListener('focus', self.focus);
  }

  this.init();
}

Date.prototype.addDays = function(days) {
  var dat = new Date(this.valueOf());
  dat.setDate(dat.getDate() + days);
  return dat;
};

function Period(options) {
  var self = this;
  var defaults = {
    input: null,
    container: null,
    dateContainer: null,
    onDisable: null,
    onEnable: null,
    frame: null,
    pristine: true,
    datePicker: null,
    startDatePicker: true,
    multipleCalendars: true,
    onChange: null,
    onShow: null,
    onError: null,
    error: true,
    dateFormatPrototypeName: null,
    onHide: null,
    date: null,
    min: null,
    max: null,
    mobile: mobilechecker(),
    commonCloseMethod: (
      // if not safari or not firefox and so != mac os
      (ua.indexOf('safari') == -1 || ua.indexOf('firefox') == -1 && ua.indexOf('mac os') != -1) ||
      // if chrome or mobile
      ua.indexOf('chrome') != -1 || mobilechecker()
    ),
    focusloose: false,
    yPosition: null,
    onSelect: null,
    defaults: {
      min: new Date(),
      max: null,
      multipleCalendars: null,
      startDatePicker:  null,
      onHide: null,
      shouldFocusOnRender: true
    }
  };
  extend(this, defaults, options);

  this.init = function() {
    var opts = {};
    extend(opts, self.defaults, {
      multipleCalendars: self.multipleCalendars,
      startDatePicker:  self.startDatePicker,
      onHide: self.onHide,
      shouldFocusOnRender: true,
      min: self.min ? self.min : self.defaults.min,
      max: self.max ? self.max : self.defaults.max
    });

    self.datePicker = DateRangePicker(self.dateContainer, {
      startOpts: opts,
      endOpts: opts
    });

    self.datePicker.on('statechange', function(_, rp) {
      var range = rp.state;
      if (self.startDatePicker) {
        self.date = range.start;
        self.frame.departureDate.hidePicker();
        self.frame.departureDate.datePicker.setSelectedStartDate(self.frame.departureDate.datePicker.state.start);
        if (!self.frame.nullEndDate) {
          self.frame.returningDate.datePicker.setSelectedStartDate(self.frame.departureDate.datePicker.state.start);


          if ((!self.frame.nullEndDate) && self.frame.returningDate.datePicker.state.start != self.frame.departureDate.datePicker.state.start) {
            self.frame.returningDate.datePicker.setMinDate(self.frame.departureDate.datePicker.state.start);

            self.frame.returningDate.setStartDate(self.frame.departureDate.datePicker.state.start);
            if (self.frame.departureDate.datePicker.state.end && self.frame.departureDate.datePicker.state.start > self.frame.departureDate.datePicker.state.end) {
              self.frame.returningDate.setEndDate(undefined);
              self.frame.departureDate.setEndDate(undefined);

              self.frame.departureDate.datePicker.setSelectedEndDate(undefined);
              self.frame.returningDate.datePicker.setSelectedEndDate(undefined);
              self.frame.returningDate.input.focus();

              if (self.frame.returningDate.input) {
                self.frame.returningDate.input.value = '';
              }

              self.frame.returningDate.date = undefined;
            }

          }
        } else {
          if (self.frame.departureDate.datePicker.state.start != self.frame.departureDate.datePicker.state.end){
            self.frame.departureDate.setEndDate(self.frame.departureDate.datePicker.state.start);
            self.frame.departureDate.datePicker.setSelectedEndDate(self.frame.departureDate.datePicker.state.start);
          }
        }

      } else {
        if (self.frame.returningDate.datePicker.state.end && self.frame.returningDate.datePicker.state.end != self.frame.departureDate.datePicker.state.end) {
          self.frame.departureDate.setEndDate(self.frame.returningDate.datePicker.state.end)
          self.frame.departureDate.datePicker.setSelectedEndDate(self.frame.returningDate.datePicker.state.end)
          self.frame.returningDate.datePicker.setSelectedEndDate(self.frame.returningDate.datePicker.state.end)

          if (!self.frame.departureDate.datePicker.state.start) {
            self.frame.departureDate.input.focus();
          }
        }
        self.date = range.end;

        self.frame.returningDate.hidePicker();
      }

      self.select();
    });

    setTimeout(function () {
      self.setDatePickersInputs(self.frame.departureDate.input, (self.frame.returningDate) ? self.frame.returningDate.input : null);
    }, 0);
  };

  this.setDatePickersInputs = function (startInput, endInput) {
    self.datePicker.setInputs(startInput, endInput);
  };

  this.validate = function(ignorePristine) {
    if (self.pristine && !ignorePristine || self.disable) {
      return;
    }

    if (!self.date) {
      handler("INVALID_VALUE", self);
      self.error = true;
      return;
    }

    self.error = false;
  };

  this.setStartDate = function(date) {
    self.datePicker.setState({
      start: date,
    });
  };

  this.setMinDate = function(date) {
    self.datePicker.setState({
      min: date
    });
  };

  this.setEndDate = function(date) {
    self.datePicker.setState({
      end: date
    });
  };

  this.showPicker = function() {
    var inputPos = self.input.getBoundingClientRect();
    var cal = self.dateContainer;
    var scrollTop = window.pageYOffset;
    var inputTop = scrollTop + inputPos.top;
    var calHeight = cal.offsetHeight;
    var belowTop = inputTop + inputPos.height + 300;
    var aboveTop = inputTop - calHeight - 300;
    var isAbove = (aboveTop > 0 && belowTop + calHeight > scrollTop + window.innerHeight);

    if (isAbove) {
      self.onShow(self.frame, "up");
    } else {
      self.onShow(self.frame, "down");
    }

    setTimeout(function() {
      self.dateContainer.focus();
    }, 10);
  };

  this.hidePicker = function() {
    self.onHide(self.frame);
  };

  this.focus = function(_) {
    self.pristine = false;
    self.showPicker();

    // if (!self.commonCloseMethod) {
    if (!self.mobile && ua.indexOf('safari') != -1 && ua.indexOf('chrome') == -1 && ua.indexOf('firefox') != -1)  {
        self.clickHandler();
    }
  };


  this.select = function() {
    self.frame.validate();
    self.onSelect(self.frame);
    self.onChange();
  };

  self.clickHandler = function(disable) {
    var body = document.getElementsByTagName('body')[0];
    if (disable) {
      body.removeEventListener('click', dateClickHandler);
      return
    }
    body.addEventListener('click', dateClickHandler);
  }

  var dateClickHandler = function(e) {
    if (!self.container.contains(e.target) && (
      e.target.className.indexOf('dp-next') == -1 && e.target.className.indexOf('dp-prev') == -1 && e.target.className.indexOf('dp-day') == -1)
    ) {
      self.hidePicker();
      self.clickHandler(true);
    }
  };

  // Closes datepicker when outside click

  // if (self.commonCloseMethod) {
  if ((ua.indexOf('safari') == -1 && ua.indexOf('firefox') == -1 && ua.indexOf('mac os') != -1) || ua.indexOf('chrome') != -1 || self.mobile) {
    var previousTimeout;
    self.container.addEventListener('focusout', function() {
      clearTimeout(previousTimeout);
      previousTimeout = setTimeout(function() {
        if (!self.container.contains(document.activeElement)) {
          self.focusloose = true;
          setTimeout(function() {
            self.validate();
          }, 1);
          self.hidePicker();
        }
      }, 0);
    });
  }


  if (this.input) {
    this.input.addEventListener('focus', this.focus);
  }
  this.init();
}

function Name(options) {
  var self = this;
  var defaults = {
    input: null,
    pristine: true,
    error: false,
    onError: {},
    onChange: null
  };
  extend(this, defaults, options);

  this.getName = function() {
    return this.input.value;
  };

  this.setName = function(value) {
    this.input.value = value;
  };

  this.validate = function(ignorePristine) {
    if (self.pristine && !ignorePristine) {
      return;
    }

    if (!self.getName()) {
      handler('INVALID_VALUE', self)
      self.error = true;
      return;
    }

    self.error = false;
  };

  this.focus = function() {
    self.pristine = false;
  };

  this.blur = function() {
    self.frame.validate();
  };

  this.change = function() {
    self.onChange();
  };

  this.input.addEventListener('focus', this.focus);
  this.input.addEventListener('input', this.change);
  this.input.addEventListener('blur', this.blur);
}

function Email(options) {
  var self = this;
  var defaults = {
    input: null,
    pristine: true,
    error: false,
    onError: {},
    onChange: null,
  };
  extend(this, defaults, options);

  this.validateEmail = function(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  this.setEmail = function(value) {
    this.input.value = value;
  };

  this.getEmail = function() {
    var email = "";
    if (self.input.value && self.input.value.indexOf("@") != -1) {
      var d = self.setDomain(self.input.value.split("@")[1]);
      email = self.input.value.split("@")[0] + '@' + d
    }

    return email;
  };

  this.validate = function(ignorePristine) {
    if (self.pristine && !ignorePristine) {
      return;
    }

    if (!self.getEmail()) {
      handler("INVALID_VALUE", self);
      self. error = true;
      return;
    }

    if (!self.validateEmail(self.input.value)) {
      handler("INVALID_VALUE", self);
      self.error = true;
      return;
    }

    self.error = false;
  };

  this.setDomain  = function(domain) {
    return (domain.indexOf('gmail') != -1)  ? 'gmail.com' :
    (domain.indexOf('hotma') != -1)  ? 'hotmail.com' :
    (domain.indexOf('outl') != -1)  ? 'outlook.com' :
    (domain.indexOf('live') != -1)  ? 'live.com' :
    (domain.indexOf('uol') != -1)  ? 'uol.com.br' :
    (domain.indexOf('yah') != -1)  ? (
      domain.indexOf('br') ? 'yahoo.com.br' : 'yahoo.com'
    ) : domain;
  };

  this.blur = function() {
    self.frame.validate();
  };

  this.focus = function() {
    self.pristine = false;
  };

  this.change = function(ev) {
    self.onChange();
  };

  this.input.addEventListener('input', this.change);
  this.input.addEventListener('blur', self.blur);
  this.input.addEventListener('focus', self.focus);
}

function Cellphone(options) {
  var self = this;
  var defaults = {
    input: null,
    pristine: true,
    error: true,
    onError: {},
    onChange: null
  };
  extend(this, defaults, options);

  this.getCellphone = function() {
    return this.input.value.replace("(", "").replace(")", "").replace("-", "");
  };

  this.validate = function(ignorePristine) {
    if (self.pristine && !ignorePristine) {
      return;
    }

    if (!self.getCellphone()) {
      handler("INVALID_VALUE", self);
      self. error = true;
      return;
    }

    if (self.getCellphone().length < 10) {
      handler("INVALID_VALUE", self);
      self.error = true;
      return;
    }

    self. error = false;
  };

  this.blur = function() {
    self.frame.validate();
  };

  this.focus = function() {
    self.pristine = false;
  };

  this.change = function(ev) {
    fMasc(this, mTel);
    self.onChange();
  };

  this.toPhone = function(value) {
    var splited = [
      value.slice(0, 2),
      (value.length == 11) ? value.slice(2, 7) : value.slice(2, 6),
      (value.length == 11) ? value.slice(7, 12) : value.slice(6, 12)
    ];

    return '(' + splited[0] + ')' + splited[1] + '-' + splited[2];
  };

  this.setPhone = function(value) {
    this.input.value = self.toPhone(value);
  };

  this.input.addEventListener('input', this.change);
  this.input.addEventListener('focus', this.focus);
  this.input.addEventListener('blur', this.blur);
}

(function(){
    /*!eslint-enable */
    if (typeof define === 'function' && define.amd) {
        define('Frame', function () { return Frame; });
        define('Destination', function () { return Destination; });
        define('Period', function () { return Period; });
        define('Cellphone', function () { return Cellphone; });
        define('Name', function () { return Name; });
        define('Email', function () { return Email; });
    } else if (typeof module !== 'undefined' && module.exports) {
    /*!eslint-enable */
        module.exports = {
          Frame: Frame,
          Destination: Destination,
          Period: Period,
          Cellphone: Cellphone,
          Name: Name,
          Email: Email
        };
    } else {
        window.Frame = Frame;
        window.Destination = Destination;
        window.Period = Period;
        window.Cellphone = Cellphone;
        window.Name = Name;
        window.Email = Email;
    }
})();

const exp = {
    Frame: Frame,
    Destination: Destination,
    Period: Period,
    Cellphone: Cellphone,
    Name: Name,
    Email: Email
  };

  export default exp;



// WEBPACK FOOTER //
// ./src/lib/sp_frame.js